declare const BUILD_NO: string;
export class BuildUtils {
  static APP_VERSION = BUILD_NO;
}
